import {loadOrbitMain} from "./orbit-main-entry-loader";

export async function startOrbitProd(): Promise<void> {
    await loadOrbitMain();
}